<div class="d-flex flex-column content-container mt-3">
    <div class="label">{{ label() | translate }}</div>
    <div class="pb-1">{{ displayedContent() }}</div>
</div>
